import styled, { css } from 'styled-components'

export const Container = styled.div`
  margin-top: 24px;
  border: 1px solid #d9d9d9;
  border-radius: 16px;
  padding: 24px;
`

export const Header = styled.div`
  cursor: pointer;
  button {
    float: left;
    padding: 0 5px;
    color: #213f68 !important;
    height: 27px;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
`

export const Title = styled.div`
  padding-left: 32px;
  font-weight: 700;
  font-size: 18px;
`

interface IContentProps {
  open: boolean
  disabled?: boolean
}

export const Content = styled.div<IContentProps>`
  overflow: hidden;
  transition: 200ms;
  tr:hover > td {
    background-color: unset !important;
  }
  .ant-row {
    margin-top: -1px;
    margin-bottom: -32px;
  }
  ${(props) =>
    !props.open &&
    css`
      height: 0;
    `}
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.65;
    `}
`

export const AccessList = styled.div`
  > div + div {
    margin-top: 16px;
    border-top: 1px solid #d9d9d9;
  }
`

export const Access = styled.div`
  padding-top: 16px;
  button {
    float: right;
  }
`

export const AccessTitle = styled.div`
  color: #363636;
  font-weight: 500;
  font-size: 14px;
  padding-right: 15px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const AccessDescription = styled.div`
  font-size: 14px;
  color: #757575;
  padding-right: 58px;
  overflow: hidden;
  text-overflow: ellipsis;
`
